"use strict";

export enum MessageType {
    UPDATE = 'update',
    PURCHASE = 'purchase'
}